"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DTOHash = void 0;
const sha256_1 = require("@noble/hashes/sha256");
const utils_1 = require("@noble/hashes/utils");
const json_stringify_deterministic_1 = __importDefault(require("json-stringify-deterministic"));
class DTOHash {
    constructor() {
        Object.defineProperty(this, "previousHash", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    get prev() {
        return this.previousHash;
    }
    async makeId(dto) {
        const hashRecord = dto;
        const thisHash = await this.hashObject(hashRecord);
        this.previousHash = thisHash;
        return thisHash;
    }
    async hashObject(obj) {
        const deterministic = (0, json_stringify_deterministic_1.default)(obj);
        const hash = (0, sha256_1.sha256)(deterministic);
        return (0, utils_1.bytesToHex)(hash);
    }
}
exports.DTOHash = DTOHash;
